export default __webpack_public_path__ + "static/media/cloud-1@2x.4577342c.png";